import styled from 'styled-components'

export const Content = styled.div`
  display: grid;
  gap: 14px;
  padding: 18px;
  background: #f5f6fa;

  @media (max-width: 640px) {
    padding: 12px;
  }
`

export const Section = styled.section`
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
`

export const CreateButton = styled.button`
  margin-top: 12px;
  border: 0;
  border-radius: 8px;
  padding: 11px 18px;
  background: #ff6200;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  &:disabled { opacity: 0.55; cursor: not-allowed; }
`

export const PaymentField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
  color: #30364d;
  font-size: var(--font-size-subtitle);

  select {
    width: 100%;
    padding: 9px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
    color: #30364d;
  }
`

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 0 14px;
  color: #1a1f3a;
  font-size: var(--font-size-body);
  font-weight: 700;

  > span {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  > svg,
  > span > svg {
    color: #ff6200;
  }
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;

  span {
    color: #8892a0;
    font-size: var(--font-size-caption);
  }

  strong {
    overflow-wrap: anywhere;
    color: #30364d;
    font-size: var(--font-size-subtitle);
    font-weight: 600;
  }
`

export const AddressCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #596174;
  font-size: var(--font-size-subtitle);

  strong {
    color: #30364d;
  }
`

export const Empty = styled.p`
  margin: 0;
  color: #8892a0;
  font-size: var(--font-size-subtitle);
`

export const Count = styled.span`
  display: grid;
  min-width: 24px;
  height: 24px;
  padding: 0 7px;
  place-items: center;
  border-radius: 999px;
  background: #fff0e7;
  color: #ff6200;
  font-size: var(--font-size-caption);
`

export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Product = styled.article`
  overflow: hidden;
  border: 1px solid #eceef3;
  border-radius: 10px;
`

export const ProductHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
`

export const Quantity = styled.span`
  display: grid;
  min-width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 8px;
  background: #fff0e7;
  color: #ff6200;
  font-size: var(--font-size-caption);
  font-weight: 700;
`

export const ProductName = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;

  strong {
    overflow-wrap: anywhere;
    color: #30364d;
    font-size: var(--font-size-subtitle);
  }

  span {
    color: #8892a0;
    font-size: var(--font-size-caption);
  }
`

export const ProductPrice = styled.strong`
  flex-shrink: 0;
  color: #30364d;
  font-size: var(--font-size-subtitle);
`

export const Additionals = styled.div`
  padding: 10px 12px 10px 52px;
  border-top: 1px solid #eceef3;
  background: #fafafa;

  div {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    color: #697185;
    font-size: var(--font-size-caption);
  }

  @media (max-width: 540px) {
    padding-left: 12px;
  }
`

export const Observation = styled.div`
  padding: 9px 12px;
  border-top: 1px solid #eceef3;
  color: #697185;
  font-size: var(--font-size-caption);
`

export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
  color: #30364d;
  font-size: var(--font-size-body);

  strong {
    color: #ff6200;
  }
`
